import { localPreferences } from 'app-components/utils/core';
import React from 'react';

/////////////////////////////////////////////
if (localPreferences.getWhyDidYouRender()) {
  // eslint-disable-next-line global-require, @typescript-eslint/no-require-imports
  const whyDidYouRender = require('@welldone-software/why-did-you-render');
  // eslint-disable-next-line global-require, @typescript-eslint/no-require-imports
  const ReactRedux = require('react-redux');
  const { virtualIncludeAll, ...localWDYRSettings } = localPreferences.getWDYRSettings();

  const wdyrSettings = {
    ...localWDYRSettings,
    ...(virtualIncludeAll && { include: [/.*/] }),
    trackExtraHooks: [[ReactRedux, 'useSelector']],
    // hotReloadBufferMs: 500,
    // include: [
    //   /.*/,
    // ],
    // exclude: [
    //   /.*/,
    // ],
    // titleColor
    // diffNameColor
    // diffPathColor
  };
  whyDidYouRender(React, wdyrSettings);
}
/////////
